import { useState, useEffect } from "react";
import { getNewsById } from "@/services/newsService";
import { NewsItem } from "@/types/news";

export const useNewsDetail = (id: string | undefined) => {
    const [news, setNews] = useState<NewsItem | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const loadNews = async () => {
            if (!id) {
                setError(true);
                setLoading(false);
                return;
            }

            try {
                const data = await getNewsById(id);
                if (data) {
                    setNews(data);
                } else {
                    setError(true);
                }
            } catch (err) {
                console.error("Error loading news:", err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        loadNews();
    }, [id]);

    return { news, loading, error };
};
